/** Сколько дней без переходов, чтобы считать ссылку убранной или сломанной. */
export const QUIET_DAYS = 14

/** Включённая метка, по которой раньше приходили, а последние две недели никого. */
export function isQuietLink(active: boolean, lastAt: string | null | undefined): boolean {
	if (!active || !lastAt) return false
	return Date.now() - new Date(lastAt).getTime() > QUIET_DAYS * 86_400_000
}
